export interface Selfie {
  cc: string;
  disabledButton: boolean;
}

export interface DocumentState {
  setSelfie: Selfie;
}

export const INITIAL_STATE_DOCUMENT: DocumentState = {
  setSelfie: {
    cc: "",
    disabledButton: true
  }
};
